
export interface CookieStorageConfig {
    signupSubdomain: string;
    cookieDomain: string;
    localStorageExpirationDays: number;
    sessionStorageExpirationDays: number;
}

export const CROSS_DOMAIN_KEYS: string[] = [
    'signupData',
    'jStorage',
    'HB_COUPON'
];

/**
 * Configuration for cookie-based storage based on environment
 * Uses environment variables or defaults to production settings
 */
export const STORAGE_CONFIG: CookieStorageConfig = {
    signupSubdomain: 'signup',
    cookieDomain: process.env.GATSBY_env === 'development' 
        ? 'localhost' 
        : process.env.GATSBY_env === 'staging' 
            ? '.hbdev.io' 
            : '.honeybook.com',
    localStorageExpirationDays: 365,
    sessionStorageExpirationDays: 1
};